import React from 'react';
import './SideMenu.css';

import Logo from '../../Assets/Images/Logo.svg'
import SideNav from './SideNav';

const SideMenu = () => {
    return (
        <div className='SideMenuContainer'>
            <aside className='SideMenu'>
                <img className='SideLogo' src={Logo} alt="" />
                <SideNav />
            </aside>
        </div>
        
     );
}
 
export default SideMenu;